export const apiUrl = `${import.meta.env.VITE_API_HOST}${import.meta.env.VITE_API_PATH}`
export const apiUrlV2 = `${import.meta.env.VITE_API_HOST}${import.meta.env.VITE_API_2_PATH}`
export const actionCableUrl = import.meta.env.VITE_ACTIONCABLE_URL
export const tdeBaseUrl = import.meta.env.VITE_TDE_BASE_URL
export const tdeAuditAppUrl = import.meta.env.VITE_TDE_AUDIT_APP_URL